@if (isFontAwesome) {
  <app-font-awesome-icon  [icon]="icon"></app-font-awesome-icon>
}
@if (!isFontAwesome) {
  <app-maticon [icon]="icon" ></app-maticon>
}
